export enum TimingStatusType {
  Undefined = "Undefined",
  Early = "Early",
  OnTime = "OnTime",
  Risk = "Risk",
  Late = "Late"
}
